import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import './index/hotelCssImport';
import '@/js/common/components/franchising/franchising-questions.scss';
import './qna-page/qna-page.scss';
import { AbstractQnaPage } from '@fr/pages/common/travelata/default-application/hotel/AbstractQnaPage';

class QnaPage extends AbstractQnaPage {}

$(() => {
  new QnaPage();
});
